export const formatDate = (str: string) =>
  new Date(str).toLocaleDateString("fi-FI");
